import React, {useEffect, useState} from 'react';
import {SectionsProps} from "../../../../../models";
import {Field, Formik} from "formik";
import {BusinessFormExpectationValidation} from "../AddBusinessValidation";
import {Button, InputField} from "../../../../../components";
import RadioField from "../../../../../components/radio-field/RadioField";

export const OtherInformation: React.FC<SectionsProps> = ({
                                                              changeStep,
                                                              setNewBusinessInfo,
                                                              newBusinessInfo,
                                                              setSectionName
                                                          }) => {

    const [committeeList] = useState<Array<{ name: string }>>([
        {name: "Membership Development"},
        {name: "Public Relations"},
        {name: "Fundraising"},
        {name: "Property Management"},
        {name: "Policy & Ethics"},
        {name: "Finance & Audit"},
    ])

    const [helpOptions] = useState<Array<string>>([
        "Word of mouth",
        "Media / Event",
        "Website",
        "Correspondence",
    ])


    const [radioOption] = useState<Array<string>>([
        "Yes",
        "No",
    ])


    useEffect(() => {
        setSectionName('Other Information')
    }, [setSectionName]);

    const [initialValues] = useState({
        other_information: newBusinessInfo?.other_information
    });


    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({
            ...prevInfo,
            other_information: values.other_information
        }))

        changeStep && changeStep("next")
        setSubmitting(false);
    }
    return (
        <div className={'add-business-section other-information'}>
            <p className={'info'}><span>Note:</span> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. </p>
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={initialValues}
                validationSchema={BusinessFormExpectationValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div className={'add-business-section_input_radio'}>
                            <span>Select the <strong>COMMITTEE</strong> of the SBAJ on which you would be willing to serve.</span>
                            <div className={'add-business-section_input_radio_list'}>
                                {committeeList.map(({name}, index) => (
                                    <RadioField
                                        key={index + "committee_service" + name}
                                        id={`other_information.committee_service.${name}`}
                                        name={'other_information.committee_service'}
                                        text={name}
                                        onchange={handleChange}
                                        value={name}
                                        checked={values.other_information.committee_service === name}
                                    />
                                ))}
                            </div>
                            <span id="--name__error" className="inputField_info_wrapper_message">
                                    {errors?.other_information?.committee_service && touched?.other_information?.committee_service && errors?.other_information?.committee_service}
                                </span>

                        </div>

                        <div className={'add-business-section_input_radio'}>
                            <div className="add-business-section_border"/>
                            <span>How did you hear about the SBAJ?</span>
                            <Field
                                name="other_information.how_did_you_find_us"
                                id={"other_information.how_did_you_find_us"}
                                as="select"
                                onBlur={handleBlur}
                                error={errors.other_information?.how_did_you_find_us && touched.other_information?.how_did_you_find_us}
                                onChange={handleChange}
                                value={values.other_information?.how_did_you_find_us}
                                className={'signup__input inputField_container_input  '}
                            >
                                <option value="" disabled hidden>Select Business Type</option>
                                {
                                    helpOptions.map((type, index) => (
                                        <option key={'c_n_o_e' + type + index} value={type}>{type}</option>
                                    ))
                                }
                            </Field>
                            <span id="--name__error"
                                  className="inputField_info_wrapper_message">{errors.other_information?.how_did_you_find_us && touched.other_information?.how_did_you_find_us && errors.other_information?.how_did_you_find_us}
                                </span>
                        </div>

                        <div className={'add-business-section_input_radio'}>
                            <span>Do you want this business to be listed in the SBAJ directory?</span>
                            <div>
                                {radioOption.map((name, index) => (
                                    <RadioField
                                        key={index + "list_in_directory" + name}
                                        id={`other_information.list_in_directory.${name}`}
                                        name={'other_information.list_in_directory'}
                                        text={name}
                                        onchange={handleChange}
                                        value={name}
                                        checked={values.other_information.list_in_directory === name}
                                    />
                                ))}
                            </div>
                            <span id="--name__error" className="inputField_info_wrapper_message">
                                    {errors?.other_information?.list_in_directory && touched?.other_information?.list_in_directory && errors?.other_information?.list_in_directory}
                            </span>
                        </div>

                        <div className={'add-business-section_input_radio'}>
                            <span>Are you employed to another company?</span>
                            <div>
                                {radioOption.map((name, index) => (
                                    <RadioField
                                        key={index + "other_employment" + name}
                                        id={`other_information.other_employment.${name}`}
                                        name={'other_information.other_employment'}
                                        text={name}
                                        onchange={handleChange}
                                        value={name}
                                        checked={values.other_information.other_employment === name}
                                    />
                                ))}
                            </div>
                            <span id="--name__error" className="inputField_info_wrapper_message">
                                    {errors?.other_information?.other_employment && touched?.other_information?.other_employment && errors?.other_information?.other_employment}
                                </span>
                        </div>

                        <div>
                            <InputField
                                id={"other_information.area_of_expertise"}
                                type="text"
                                classname="signup__input"
                                placeholder={"Eg: 'management'"}
                                name="other_information.area_of_expertise"
                                onblur={handleBlur}
                                error={errors.other_information?.area_of_expertise && touched.other_information?.area_of_expertise}
                                onchange={handleChange}
                                message={errors.other_information?.area_of_expertise && touched.other_information?.area_of_expertise && errors.other_information?.area_of_expertise}
                                inputValue={values.other_information?.area_of_expertise}
                                label={'What is your area of expertise?'}
                            />
                        </div>

                        <div className={'add-business-section_cta'}>
                            <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                            <Button type={"primary"} isSubmit={true} text={"Next"}/>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};
